<div class="container-fluid">
    <div class="row">
        <div class="col-md-6 footer-copyright">
            <p class="mb-0">Copyright 2023 © ANRE Toate drepturile rezervate.</p>
        </div>
    </div>
</div>
